import Chip from '@styles/design-system/components/chips/chip';
import classes from './dynamic-audience-chip.module.css';

function DynamicAudienceChip() {
  return <Chip label="Dynamic" size={24} type="info" noHover selectProps={{ className: classes.dynamicChip }} />;
}

export default DynamicAudienceChip;
